import React from 'react';
import PropTypes from 'prop-types';
import ReactToggle from 'react-toggle';
import './Toggle.scss';

class Toggle extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	handleChange = (event) => {
		this.props.onChange(this.props.name, event.target.checked);
	};

	render() {
		return (
			<div className='mb-3 toggle' style={this.props.style ? this.props.style : {}}>
				<div className='react-toggle-box'>
					<ReactToggle
						checked={this.props.checked}
						icons={true}
						onChange={this.handleChange}
						disabled={this.props.isDisabled ? this.props.isDisabled : false}
					/>
				</div>
				<div className='react-toggle-text'>{this.props.text}</div>
			</div>
		);
	}
}

Toggle.propTypes = {
	name: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	style: PropTypes.object,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	isDisabled: PropTypes.bool,
};

export default Toggle;
